import React from 'react';
import { Box, Button } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../../RoutableSitecoreLink';
import themeStyles from '../styles/Card.styles';
const CTAWrapper = themeStyles.apply(Box, 'CTAWrapper');
const StyledButton = themeStyles.apply(Button, 'StyledButton');
const CTA = ({ cta, styles }) => {
    const { text, href, linktype, target, gtmEvent, params, label } = cta || {};
    if (!href)
        return null;
    const searchParams = new URLSearchParams(params);
    return (React.createElement(CTAWrapper, { style: styles },
        React.createElement(StyledButton, { styling: "secondary", as: RoutableSitecoreLink, ariaLabel: `${text} ${label}`, field: {
                value: {
                    linktype,
                    href,
                    target,
                    querystring: searchParams,
                },
            }, onClick: () => {
                if (typeof gtmEvent === 'function') {
                    gtmEvent();
                }
            } }, text)));
};
export default CTA;
